import { Dialog, Slide } from "@mui/material";
import React, { forwardRef, useEffect, useState } from "react";
import ChoiceField from "../GlobalFeature/Table/ChoiceField";
import { createOption, deleteOption, getOptions, updateOption } from "../../utils/api/customTemplatesApi";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import ClearIcon from "@mui/icons-material/Clear";
import icon from "../../assets/images/linkIcon.svg";
import { useLazyFetchFieldValuesQuery } from "../../utils/customer/customerSelect";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { useAddUpdateGlobalListMutation, useGetGlobalDropdownQuery } from "../ActivityLogs/AuditLogAPIS";
import Button from "../UniversalComponents/DefaultButton";
import SelectComponent from "../UniversalComponents/SelectComponent";
import ConfirmationDialogMulti from "../UniversalComponents/ConfirmationDialogMulti";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const optionListCurrency = [
  { label: "₹", value: "INR" },
  { label: "$", value: "USD" },
  { label: "€", value: "EUR" },
  { label: "£", value: "GBP" },
  { label: "¥", value: "JPY" },
];

const negativeNumberList = [
  { label: <p>-1234</p>, value: "minus" },
  { label: <p className="text-[#FF0000]">1234</p>, value: "red" },
  {
    label: (
      <p>
        {"("}1234{")"}
      </p>
    ),
    value: "parentheses",
  },
  {
    label: (
      <p className="text-[#FF0000]">
        {"("}1234{")"}
      </p>
    ),
    value: "red-parentheses",
  },
];

const InputModal = ({ handleAddInput, dragCapture, setDragCapture }) => {
  const [inputs, setInputs] = useState({
    name: dragCapture?.data?.inputValue ?? "",
    description: dragCapture?.data?.inputDescription ?? "",
    decimalPlaces: dragCapture?.data?.inputMeta?.numberFormat?.decimalPlaces ?? 0,
    separatorInput: dragCapture?.data?.inputMeta?.numberFormat?.separators ?? ",",
    negativeNumber: dragCapture?.data?.inputMeta?.numberFormat?.negativeFormat ?? "red",
    options: [],
    symbol: dragCapture?.data?.inputMeta?.numberFormat?.symbol ?? "$",
    multiPerson: dragCapture?.data?.inputMeta?.multiPerson ?? false,
    allowMultiple: dragCapture?.data?.inputType === "multiselect",
  });

  const {
    data: globalDropdownData,
    isLoading: globalDropdownLoading,
    isFetching: globalDropdownFetching,
    isError: globalDropdownError,
    error: globalDropdownErrorData,
    isSuccess: globalDropdownSuccess,
    refetch: getGlobalDropdownRefetch,
  } = useGetGlobalDropdownQuery(undefined, {
    // skip: !open || !(selectedOption?.label === "Choice" && isCloned),
    // refetchOnFocus: false,
    // refetchOnReconnect: false,
    // refetchOnMount: false,
    // refetchOnMountOrArgChange: false,
  });

  const [
    saveGlobalDropdown,
    {
      data: saveCopytoGlobalData,
      isLoading: copyToGlobalDataLoading,
      isSuccess: copyToGlobalDataSuccess,
      isError: copyToGlobalDataIsError,
      error: copyToGlobalDataError,
    },
  ] = useAddUpdateGlobalListMutation();
  const [
    FetchFieldValues,
    {
      data: GetFieldValues,
      isError: isFieldValuesError,
      isSuccess: isFieldValuesSuccess,
      error: FieldValuesError,
      isLoading: isFieldValuesLoading,
    },
  ] = useLazyFetchFieldValuesQuery();
  // 🔁 HANDLE DELETE SECTION
  useEffect(() => {
    if (isFieldValuesLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isFieldValuesSuccess && GetFieldValues?.status) {
      dispatch(
        pushAlert({
          message: GetFieldValues?.message || "Section deleted successfully",
          type: "success",
          visible: true,
        })
      );

      setInputs((prev) => ({
        ...prev,
        options: GetFieldValues?.data?.map((option) => ({
          id: option?.id,
          value: option?.label,
          color_code: option?.color_code,
        })),
      }));

      setExtraFieldData({
        fieldId: dragCapture?.data?.inputId,
        field_options: GetFieldValues?.data?.map((option) => ({
          id: option?.id,
          value: option?.label,
          color_code: option?.color_code,
        })),
      });
      setPrevFielddata({
        fieldId: dragCapture?.data?.inputId,
        field_options: GetFieldValues?.data?.map((option) => ({
          id: option?.id,
          value: option?.label,
          color_code: option?.color_code,
        })),
      });
    } else if (isFieldValuesError) {
      dispatch(
        pushAlert({
          message: FieldValuesError?.data?.message || "Error deleting section",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isFieldValuesError, isFieldValuesLoading, isFieldValuesSuccess, GetFieldValues, FieldValuesError]);

  // -------------------------------------CHOICE FIELD----------------------------------
  const [extraFieldData, setExtraFieldData] = useState({
    field_options: ["tags"].includes(dragCapture?.data?.inputType)
      ? [
          { value: "tag 1", color_code: "#782AEE" },
          { value: "tag 2", color_code: "#DB4A6B" },
          { value: "tag 3", color_code: "#C46D3A" },
          { value: "tag 4", color_code: "#E38BAB" },
          { value: "tag 5", color_code: "#3DB22A" },
        ]
      : [],
    fieldId: dragCapture?.data?.inputId,
  });
  const [inputValue, setInputValue] = useState("");
  const [InputVisible, setInputVisible] = useState(false);
  const [isEmptyOption, setIsEmptyOption] = useState(false);
  const [shadowColor, setShadowColor] = useState("#5F5E52");
  const [prevFielddata, setPrevFielddata] = useState(null);
  const [selectedGlobalList, setSelectedGlobalList] = useState(null);
  const [isCloned, setIsCloned] = useState(false);

  const dispatch = useDispatch();
  const [isCopyToGlobalList, setIsCopyToGlobalList] = useState(false);
  const [copyToGlobalListFormData, setCopyToGlobalListFormData] = useState({
    globalListname: "",
    ChoiceValues: [],
  });
  const [isDuplicate, setIsDuplicate] = useState("");

  const removeChoiceApi = async (choice) => {
    try {
      const response = await deleteOption({ params: { id: choice?.id } });
      if (response?.status) {
        dispatch(pushAlert({ visible: true, message: response?.message || "Success", type: "success" }));
        handleGetOptions();
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message || "Something went wrong", type: "danger" }));
      }
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
    // setExtraFieldData((prev) => ({
    //   ...prev,
    //   field_options: prev.field_options.filter((c) => c !== choice),
    // }));
    // setInputs((prev) => ({
    //   ...prev,
    //   options: prev.options.filter((o) => o.value !== choice.value),
    // }));
  };

  const handleFieldOptionUpdate = async (updatedOption) => {
    try {
      const response = await updateOption({
        query: { field_name: dragCapture?.data?.inputUniqueName },
        body: { id: updatedOption?.id, value: updatedOption?.value, color: updatedOption?.color_code },
      });

      if (response?.status) {
        dispatch(pushAlert({ visible: true, message: response?.message || "Success", type: "success" }));
        handleGetOptions();
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message || "Something went wrong", type: "danger" }));
      }
      // setInputs((prev) => ({
      //   ...prev,
      //   options: prev.options.map((o) => (o.value === updatedOption.value ? updatedOption : o)),
      // }));
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  const handleFieldOptionAdd = async (newOption) => {
    try {
      let body = {
        value: newOption?.value,
        color: newOption?.color_code,
      };
      const response = await createOption({ query: { field_name: dragCapture?.data?.inputUniqueName }, body });
      if (response?.status) {
        handleGetOptions();
        dispatch(pushAlert({ visible: true, message: response?.message || "Success", type: "success" }));
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message || "Something went wrong", type: "danger" }));
      }
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  const handleGetOptions = async () => {
    try {
      FetchFieldValues({ FieldName: dragCapture?.data?.inputUniqueName });
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message || "Something went wrong", type: "danger" }));
    }
  };

  // -------------------------------------CHOICE FIELD----------------------------------

  const handleClose = () => {
    setDragCapture({ isOpen: false, data: {} });
  };

  const handleCloneToggle = () => {
    setIsCloned((prev) => {
      const newValue = !prev;
      if (!newValue) {
        setSelectedGlobalList([]);
        setExtraFieldData((prevData) => ({
          ...prevData,
          field_options: [],
        }));
      }
      return newValue;
    });
  };

  const handleFormSubmit = () => {
    // event.preventDefault();
    // if (dragCapture?.data?.inputId) {
    //   handleEditInput({
    //     sectionId: dragCapture?.data?.sectionId,
    //     ...inputs,
    //     inputId: dragCapture?.data?.inputId,
    //   });
    // } else {
    handleAddInput({
      ...inputs,
      options: extraFieldData?.field_options,
      type: dragCapture?.data?.inputType,
      sectionId: dragCapture?.data?.sectionId,
      inputId: dragCapture?.data?.inputId,
    });
    // }
  };

  // useEffect(() => {
  //   initialInputs.forEach((input) => {
  //     if (input.inputType === dragCapture?.data?.inputType) {
  //       setInputs((prev) => ({
  //         ...prev,
  //         inputLabel: input.inputName,
  //       }));
  //     }
  //   });
  // }, [dragCapture?.data?.inputType]);

  useEffect(() => {
    if (
      (dragCapture?.data?.inputType === "choice" ||
        dragCapture?.data?.inputType === "tags" ||
        dragCapture?.data?.inputType === "dropdown" ||
        dragCapture?.data?.inputType === "person" ||
        dragCapture?.data?.inputType === "multiselect") &&
      dragCapture?.data?.inputId
    ) {
      handleGetOptions();
    }
  }, [dragCapture?.data?.inputType, dragCapture?.data?.inputId]);

  const handleGlobalListDialogClose = () => {
    setIsCopyToGlobalList(false);
    setCopyToGlobalListFormData({ globalListname: "", ChoiceValues: [] });
    setIsDuplicate("");
  };
  const handleCheckDuplicateList = (listName) => {
    const isDuplicateName = globalDropdownData?.data?.some(
      (item) => item.name.toLowerCase() === listName.toLowerCase()
    );
    if (isDuplicateName) {
      setIsDuplicate("This Global name is already exists. Please enter a different name ");
    } else {
      setIsDuplicate("");
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setCopyToGlobalListFormData((prev) => ({
      ...prev,
      globalListname: value,
    }));
    handleCheckDuplicateList(value);
  };

  const handleGlobalListSelect = (val) => {
    const selectedValues = val[0]?.values || [];
    setSelectedGlobalList(selectedValues);
    setExtraFieldData((prev) => ({
      ...prev,
      field_options: selectedValues.map((item) => ({ value: item.label, color_code: item.color_code, id: item.id })),
    }));
  };

  const handleCopyToGlobalSave = () => {
    if (isDuplicate || !copyToGlobalListFormData.globalListname.trim()) return;

    const payload = {
      label: copyToGlobalListFormData.globalListname.trim(),
      name: copyToGlobalListFormData.globalListname.trim(),
      values: extraFieldData.field_options.map((opt) => ({
        label: opt.value,
        color: opt.color_code || null,
      })),
    };

    saveGlobalDropdown(payload);
  };

  useEffect(() => {
    if (copyToGlobalDataLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (copyToGlobalDataSuccess) {
      dispatch(
        pushAlert({
          message: saveCopytoGlobalData?.message || "List saved successfully",
          type: saveCopytoGlobalData?.success ? "success" : "danger",
          visible: true,
        })
      );
      getGlobalDropdownRefetch();

      if (saveCopytoGlobalData?.success) {
        setCopyToGlobalListFormData({
          globalListname: "",
          ChoiceValues: [],
        });
        handleGlobalListDialogClose();
      }
    }

    if (copyToGlobalDataIsError) {
      dispatch(
        pushAlert({
          message: copyToGlobalDataError?.data?.message || "Failed to save list",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [copyToGlobalDataLoading, copyToGlobalDataSuccess, copyToGlobalDataIsError]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={dragCapture?.isOpen}
      onClose={handleClose}
      PaperProps={{ className: "rounded-2xl shadow-xl mt-10" }}
      TransitionComponent={Transition}
      keepMounted
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-start",
        },
      }}
    >
      <div className="flex flex-col gap-y-2 pt-4 pb-4 w-full h-full">
        {/* Header */}

        {!["tags"].includes(dragCapture?.data?.inputType) && (
          <>
            <div className="flex items-center justify-between px-4 gap-2">
              <p className="font-semibold text-lg text-gray-800">
                {/* {dragCapture?.data?.inputId ? "Updating " : "Creating "} */}
                <span className="font-semibold text-primary text-xl">
                  {dragCapture?.data?.inputId ? dragCapture?.data?.inputValue : dragCapture?.data?.inputName}
                </span>{" "}
                {/* in <span className="font-semibold text-[#004EFF] text-xl">{dragCapture?.data?.sectionName}</span> */}
              </p>

              <div className=" flex items-center justify-center gap-x-2">
                {(dragCapture?.data?.inputId && dragCapture?.data?.inputType === "choice") ||
                dragCapture?.data?.inputType === "tags" ? (
                  <div className="flex justify-end ">
                    <button
                      className=" flex gap-3 items-center border px-3 py-1 rounded-md hover:bg-gray-100 w-max "
                      onClick={() => setIsCopyToGlobalList(true)}
                    >
                      <span className="whitespace-nowrap text-sm text-primary ">Copy To</span>
                      <img src={icon} alt="Link Icon" className="text-gray-500 cursor-pointer" />
                    </button>

                    {isCopyToGlobalList && (
                      <Dialog
                        open={isCopyToGlobalList}
                        onClose={handleGlobalListDialogClose}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{
                          className: "rounded-lg p-6 max-w-sm w-full bg-white shadow-lg",
                        }}
                      >
                        {/* Header */}
                        <div className="flex justify-between items-start mb-4">
                          <h2 className="text-lg font-semibold text-gray-800">Copy to Global List</h2>
                          <button
                            onClick={handleGlobalListDialogClose}
                            className="text-gray-400 hover:text-gray-600 text-xl leading-none"
                          >
                            &times;
                          </button>
                        </div>

                        <div className="space-y-2 mb-6">
                          <label className="block text-gray-700 text-sm font-medium">Enter a name</label>
                          <input
                            type="text"
                            placeholder="Enter a name"
                            value={copyToGlobalListFormData.globalListname}
                            maxLength={25}
                            onChange={handleNameChange}
                            className={`h-9 px-3 border rounded-md capitalize bg-white focus:outline-hidden focus:ring-0 block w-full text-sm font-normal ${
                              isDuplicate ? "border-red-500" : "border-gray-300 focus:border-blue-500"
                            }`}
                          />
                          {isDuplicate && <p className="text-red-500 text-xs mt-1">{isDuplicate}</p>}
                        </div>

                        <div className="flex justify-end gap-3">
                          <Button onClick={handleGlobalListDialogClose} variant="secondary">
                            Cancel
                          </Button>
                          <Button onClick={handleCopyToGlobalSave} variant="primary">
                            Save
                          </Button>
                        </div>
                      </Dialog>
                    )}
                  </div>
                ) : (
                  <div className="flex items-center justify-end gap-x-3 w-full">
                    {["choice", "multiselect", "tags"].includes(dragCapture?.data?.inputType) && (
                      <div className="flex items-center gap-3 h-8 justify-between px-2 py-1 rounded-md w-full">
                        <span className="text-sm font-medium text-[#313131cc]">Copy From </span>

                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={isCloned}
                            onChange={handleCloneToggle}
                          />
                          <div
                            className="w-8 h-4 bg-gray-300 rounded-full peer-focus:outline-none
    peer-checked:bg-primary relative
    after:content-[''] after:absolute after:top-[2px] after:left-[2px]
    after:bg-white after:border after:border-gray-300 after:rounded-full
    after:h-3 after:w-3 after:transition-all
    peer-checked:after:translate-x-4"
                          ></div>
                        </label>
                      </div>
                    )}
                  </div>
                )}
                <ClearIcon onClick={handleClose} size={20} className="text-[#767676] cursor-pointer" />
              </div>
            </div>

            {isCloned && ["choice", "multiselect", "tags"].includes(dragCapture?.data?.inputType) && (
              <div className="w-full flex items-start flex-col px-4 gap-2">
                <label className="text-sm font-medium text-gray-600">Global List</label>

                <SelectComponent
                  options={globalDropdownData?.data}
                  labelKey="label"
                  valueKey="id"
                  name="Choose a global list "
                  onChange={handleGlobalListSelect}
                  onClick={() => {}}
                  type={"select"}
                  size={"medium"}
                  label="a Global list"
                  noFormInput
                  placeholder="Select Global List"
                />
              </div>
            )}

            {/* Name */}
            <div className="flex flex-col gap-1 px-4">
              <div className="flex">
                <label htmlFor="name" className="text-sm font-medium text-gray-600">
                  Name
                </label>
                <div className="text-red-600">*</div>
              </div>
              <input
                autoFocus
                required
                type="text"
                placeholder="Enter your name"
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primarty-90 focus:outline-none"
                value={inputs?.name}
                onChange={(e) => setInputs((prev) => ({ ...prev, name: e.target.value }))}
              />
            </div>

            {/* Description */}
            <div className="flex flex-col gap-1 px-4">
              <label htmlFor="description" className="text-sm font-medium text-gray-600">
                Description
              </label>
              <textarea
                placeholder="Description"
                rows={3}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-90 focus:outline-none resize-none"
                value={inputs?.description}
                onChange={(e) => setInputs((prev) => ({ ...prev, description: e.target.value }))}
              />
            </div>
          </>
        )}
        {["tags"].includes(dragCapture?.data?.inputType) && (
          <>
            <div className="flex items-center justify-between px-4">
              <p className="font-semibold text-lg text-gray-800">
                {/* {dragCapture?.data?.inputId ? "Updating " : "Creating "} */}
                <span className="font-semibold text-primary text-xl">
                  {dragCapture?.data?.inputId ? dragCapture?.data?.inputValue : dragCapture?.data?.inputName}
                </span>{" "}
                {/* in <span className="font-semibold text-[#004EFF] text-xl">{dragCapture?.data?.sectionName}</span> */}
              </p>

              <div className=" flex items-center justify-center gap-x-2">
                <ClearIcon onClick={handleClose} size={20} className="text-[#767676] cursor-pointer" />
              </div>
            </div>
          </>
        )}

        {/* Decimal Places & Currency */}
        <div className="flex justify-between w-full gap-3 px-4">
          {["number", "currency", "percentage"].includes(dragCapture?.data?.inputType) && (
            <label className="flex flex-col w-1/2">
              <span className="text-sm font-medium text-gray-600">Decimal places</span>
              <input
                type="number"
                min={0}
                value={inputs?.decimalPlaces}
                onChange={(e) => setInputs((prev) => ({ ...prev, decimalPlaces: +e.target.value }))}
              />
            </label>
          )}
          {["currency"].includes(dragCapture?.data?.inputType) && (
            <label className="flex flex-col w-1/2">
              <span className="text-sm font-medium text-gray-600">Symbol</span>
              <select
                value={inputs?.symbol}
                onChange={(e) => setInputs((prev) => ({ ...prev, symbol: e.target.value }))}
                className="py-1"
              >
                {optionListCurrency.map((currency) => (
                  <option key={currency.value} value={currency.label}>
                    {currency.label}
                  </option>
                ))}
              </select>
            </label>
          )}
        </div>

        {/* Separator + Negative Numbers */}
        {["number", "currency"].includes(dragCapture?.data?.inputType) && (
          <div className="flex justify-between w-full gap-3 px-4">
            <label className="flex gap-3 items-center">
              <input
                type="checkbox"
                checked={!!inputs?.separatorInput}
                onChange={(e) => setInputs((prev) => ({ ...prev, separatorInput: e.target.checked }))}
              />
              Use 1000 Separator (,)
            </label>
            <div className="flex flex-col gap-1">
              <span className="text-sm font-medium text-gray-600">Negative Numbers</span>
              <div className="flex gap-3">
                {negativeNumberList.map((s) => (
                  <button
                    type="button"
                    key={s.value}
                    onClick={() => setInputs((prev) => ({ ...prev, negativeNumber: s.value }))}
                    className={`bg-gray-100 p-2 rounded-md ${
                      inputs?.negativeNumber === s.value && "border-[1px] border-indigo-500"
                    }`}
                  >
                    {s.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Multi Person */}
        {["person"].includes(dragCapture?.data?.inputType) && (
          <div className="flex justify-between w-full gap-3 px-4">
            <label className="flex gap-3 items-center">
              <input
                type="checkbox"
                checked={inputs?.multiPerson}
                onChange={(e) => setInputs((prev) => ({ ...prev, multiPerson: e.target.checked }))}
              />
              Multi Person
            </label>
          </div>
        )}

        {/* Choice Field */}
        {["choice", "dropdown", "multiselect", "tags"].includes(dragCapture?.data?.inputType) && (
          <div className="flex w-full flex-col min-h-[10vh] max-h-[40vh]  overflow-auto gap-1 px-4 py-1">
            <ChoiceField
              extraFieldData={extraFieldData}
              setExtraFieldData={setExtraFieldData}
              inputValue={inputValue}
              setInputValue={setInputValue}
              InputVisible={InputVisible}
              setInputVisible={setInputVisible}
              allowMultiple={inputs.allowMultiple}
              setAllowMultiple={(val) => setInputs((prev) => ({ ...prev, allowMultiple: val }))}
              removeChoiceApi={removeChoiceApi}
              handleFieldOptionUpdate={handleFieldOptionUpdate}
              handleFieldOptionAdd={handleFieldOptionAdd}
              setShadowColor={setShadowColor}
              shadowColor={shadowColor}
              setIsEmptyOption={setIsEmptyOption}
              isEmptyOption={isEmptyOption}
              EditFieldData={prevFielddata}
              isTagsField={dragCapture?.data?.inputType === "tags"}
            />
          </div>
        )}

        {/* Actions */}
        <div className="flex justify-end items-center px-4">
          {/* <button className="px-4 py-2 rounded-lg text-[#5489FF]" type="reset" onClick={handleClose}>
            Don't Save This Field
          </button> */}

          <button
            className={`px-4 py-2 rounded-lg text-white ${inputs?.name || ["tags"].includes(dragCapture?.data?.inputType) ? "cursor-pointer" : "cursor-not-allowed"} bg-primary-90 hover:bg-primary transition`}
            onClick={handleFormSubmit}
            type="button"
            disabled={["tags"].includes(dragCapture?.data?.inputType) ? false : !inputs?.name ? true : false}
          >
            Done
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default InputModal;
